import React, { useEffect, useState } from 'react';
import { Dialog, Image, Spinner, T } from '@colonist/ui';
import { passThroughTranslation } from '@colonist/i18n';
import styles from './PatchNoteImageDialog.module.scss';
export function PatchNoteImageDialog({ open, onClose, title, imageUrl, alt }) {
    const [status, setStatus] = useState('loading');
    useEffect(()=>{
        setStatus('loading');
    }, [
        imageUrl
    ]);
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: title
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, status == 'loading' ? /*#__PURE__*/ React.createElement("div", {
        className: styles.loadingContainer,
        role: "status",
        "aria-live": "polite",
        "aria-label": "Loading image"
    }, /*#__PURE__*/ React.createElement(Spinner, {
        className: styles.spinner
    })) : null, status == 'error' ? /*#__PURE__*/ React.createElement("span", {
        className: styles.error,
        role: "alert",
        "aria-live": "assertive"
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.patchNote.imageFailedToLoad'
        }
    })) : null, /*#__PURE__*/ React.createElement(Image, {
        className: styles.image,
        image: {
            src: imageUrl,
            alt: passThroughTranslation(alt)
        },
        onLoad: ()=>setStatus('loaded'),
        onError: ()=>setStatus('error'),
        hidden: status != 'loaded'
    }))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onClose
    })));
}
